import Swal from 'sweetalert2';
import axios from 'axios';
import ProductGroupSearchMixin from '../../mixins/ProductGroupSearchMixin';
import template from './AttachProductGroupAdditionalData.html';

export default {
  template,

  name: 'AttachProductGroupAdditionalData',

  mixins: [ProductGroupSearchMixin],

  props: {
    additionalData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    attachAdditionalData(productGroup) {
      Swal.fire({
        title: 'Er du sikker på du ønsker å utføre handlingen?',
        text: `Det vil føre til at du tilknytter ${this.additionalData.title} til ${productGroup.name}. Du blir sendt til oversikt siden dersom tilknyttningen er vellykket.`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Ja, tilknytt!',
        cancelButtonText: 'Avbryt',
      }).then((result) => {
        if (result.value) {
          axios.put('/admin/api/v1/product-group/attach-additional-data', {
            product_group: productGroup,
            additional_data_id: this.additionalData.id,
          })
            .then(() => {
              window.location.href = '/additional-data/product-group';
            })
            .catch(() => {
              Swal.fire('Feil', 'Kunne ikke utføre tilknytning.', 'error');
            });
        }
      });
    },
  },
};
